function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#automations_svg__clip0_5489_18449)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.687 11.839c-2.227 3.032-3.094 5.896-1.924 7.066 1.526 1.526 5.93-.402 9.835-4.308 3.905-3.905 5.833-8.308 4.307-9.834-1.526-1.526-5.928.403-9.833 4.308l-.79.79",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.839 17.112c3.032 2.228 5.896 3.095 7.066 1.924 1.526-1.526-.402-5.929-4.308-9.834-3.905-3.906-8.308-5.834-9.834-4.308-1.526 1.526.403 5.928 4.308 9.834l.79.79",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 1,
  fill: "#0063E3"
}));

var SvgAutomations = function SvgAutomations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "3 3 18 18",
    stroke: "#D8DAE7"
  }, props), _ref);
};

export default SvgAutomations;